import { FamilyMember } from '@/types';
import { generateConnectorPath } from '@/utils/tree/connectors';
import { TREE_CONFIG } from '@/config';

interface TreeConnectorsProps {
  members: FamilyMember[];
  nodePositions: Map<string, { x: number; y: number }>;
  nodeWidth: number;
  nodeHeight: number;
}

export function TreeConnectors({ members, nodePositions, nodeWidth, nodeHeight }: TreeConnectorsProps) {
  return (
    <>
      {members.map(member =>
        member.children.map(childId => {
          const parentPos = nodePositions.get(member.id);
          const childPos = nodePositions.get(childId);
          
          if (!parentPos || !childPos) return null;

          return (
            <path
              key={`${member.id}-${childId}`}
              d={generateConnectorPath(
                parentPos.x + nodeWidth / 2,
                parentPos.y + nodeHeight,
                childPos.x + nodeWidth / 2,
                childPos.y
              )}
              stroke={TREE_CONFIG.CONNECTOR.COLOR}
              strokeWidth={TREE_CONFIG.CONNECTOR.WIDTH}
              fill="none"
              className="transition-colors duration-200"
            />
          );
        })
      )}
    </>
  );
}